import React from 'react';
import QuestionWrapper from '../../ui/question_wrapper';
import QuestionHeading from '../../ui/question_heading';
import QuestionSubheading from '../../ui/question_subheading';
import RadioPillGroup from '../../ui/radio_pill_group';
import TextInput from '../../ui/text_input';
import { useQuestionnaireStep } from '../../../../wrappers/question_wrapper/step_context';

const RadioPillQuestion = ({
  heading,
  subHeading,
  name,
  options,
  value,
  onChange,
  onSubmit,
  onBack,
  current,
  total,
  ariaLabel,
  showNavButtons = true,
  submitDisabledWhenEmpty = true,
  showOther = false,
  otherValue = '',
  onOtherChange,
  otherPlaceholder = 'Other',
}) => {
  const step = useQuestionnaireStep();
  const resolvedCurrent = current ?? step.current;
  const resolvedTotal = total ?? step.total;
  const valueEmpty = value === undefined || value === null || value === '';
  const otherEmpty = !otherValue || otherValue.trim() === '';
  const isDisabled = submitDisabledWhenEmpty && valueEmpty && otherEmpty;
  return (
    <QuestionWrapper
      current={resolvedCurrent}
      total={resolvedTotal}
      onBack={onBack}
      onSubmit={onSubmit}
      isDisabled={isDisabled}
      showNavButtons={showNavButtons}
    >
      <QuestionHeading>{heading}</QuestionHeading>
      {subHeading && <QuestionSubheading>{subHeading}</QuestionSubheading>}
      <RadioPillGroup
        name={name}
        options={options}
        value={value}
        onChange={onChange}
        ariaLabel={ariaLabel || heading}
      />
      {showOther && (
        <TextInput
          value={otherValue}
          onChange={onOtherChange}
          placeholder={otherPlaceholder}
          ariaLabel={otherPlaceholder}
        />
      )}
    </QuestionWrapper>
  );
};

export default RadioPillQuestion;
